import { ActionType, ProfileActions } from './actions';
import { ProfileState } from "./state";


export function profileReducer(state: ProfileState, action: ProfileActions): ProfileState {
    switch (action.type) {
        case ActionType.SetSelectedTab:
            return { ...state, selectedTab: action.payload.selectedTab };

            default:
                return state;    
    }
}
